export default {
  methods: {
    _ruleRequired (msg) {
      var errorMsg = msg || 'This is required.'
      return value => !!value || errorMsg
    },
    _ruleEmail (msg) {
      return v => {
        var errorMsg = msg || 'Please provide a valid email address.'
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return v ? pattern.test(v) || errorMsg : true
      }
    },
    _unformat$ (value) {
      return Number(value.replace(/[^0-9.-]+/g, ''))
    }
  }
}
